import React, { useContext, useEffect, useRef, useState } from 'react';
import './allsportdata.css';

import { Link, useLocation } from 'react-router-dom';
import icVir from '../../assets/images/ic_vir.png';
import config from '../../config.js';
import BackPricesBoxExch from '../box/BackPricesBoxExch.jsx';
import LayPricesBoxExch from '../box/LayPricesBoxExch.jsx';
import { useMatchOddsWebSocket } from '../../world-refactored.js';

function AllsportdataTest({ matchData,selectedTypes }) {
    const [updateMatchOdds, setStateValue] = useState();
    const [types, setTypes] = useState();
    const initialized = useRef(false);
    const [multimarketArrrrr, setMultimarketArrrrr] = useState([])
    const location = useLocation();

    const { matchOdd, isConnected, reconnectAttempts } = useMatchOddsWebSocket(
    matchData,
    {
      wssLink: config.wssLink,
      Topic_Match_Odds: config.Topic_Match_Odds,
    }
  );  

    useEffect(() => {
        setStateValue(matchData);
        setTypes(selectedTypes);  
    }, [matchData,selectedTypes,location]);


    const validation = (price) => {
        if(price &&
            price !== '-' &&
            price !== 0 &&
            price <= 1000.00){
                return true
            }else{
                return false
            }
    }

    const getMatchOdds = (matchdata) =>{
        const marketId = matchdata.matchodd.find(odd => odd.marketName === "Match Odds")?.marketId || null;
        if (marketId && matchOdd) {
            if (matchOdd[marketId]) {
                return matchOdd[marketId]
                // console.log(matchOdd[marketId],"matchOdd[marketId]matchOdd[marketId]");
            }else{
                return matchdata.matchodd[0];
            }
        }else{
            return matchdata.matchodd[0];
        }
    }

    useEffect(() => {
        if (!initialized.current) {
          initialized.current = true;
          if (sessionStorage.getItem('userId')) {
            // callAPI();
          }
        }

    }, []);

    const callAPI = () => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          redirect: "follow",
        };

        fetch(`${process.env.REACT_APP_BASE_URL}/getmultimarket`, requestOptions)
          .then(async (response) => {
            let paresData = await response.json();
            setMultimarketArrrrr(paresData.muliMarketArray);
          })
          .catch((error) => {
            console.log(error);
          });
    };

    const dateFormet = (date)=>{
        return new Date(date).toLocaleString('en-US', {
            month: 'short',
            day: '2-digit',
            hour: 'numeric',
            minute: '2-digit',
            hour12: false
        })
    }

  const getLock = () => {
       // <img src='../images/lock.svg' alt='as'/>
       return <i className="fa fa-lock"></i>
    }

  const validationBM = (price) => {
       if (price &&
          price != '-' &&
          price != 0) {
          return true
       } else {
          return false
       }
    }



    const renderData = (gameItem) => {
        let lastSeries = null;
        // console.log(gameItem.matchData,"---gameItem.matchData");
        
        return (gameItem && gameItem.matchData && gameItem.matchData.length > 0 ?
            gameItem.matchData.map((matchItem, matchindex) => {
            let currentCompetitionName
            let shouldShow
            if(!matchItem.casinoStatus && !["7","4339"].includes(matchItem.match.sportId)){
                currentCompetitionName = matchItem.match.competitionName;
                shouldShow = lastSeries !== currentCompetitionName;
                lastSeries = currentCompetitionName;
            }else{
                if (matchItem.casinoStatus) {
                    
                }else{
                    currentCompetitionName = matchItem.match.competitionName.split("-")[0];
                    shouldShow = lastSeries !== currentCompetitionName;
                    lastSeries = currentCompetitionName;
                }
            }

            // Update matchItem if a match is found
                if (matchItem != null) {
                    if(Array.isArray(matchItem.matchodd) && matchItem.matchodd.length > 0 ){
                        if(matchItem.matchodd[0].runners !== undefined ){
                            if (Array.isArray(matchItem.matchodd[0].runners)) {
                                getMatchOdds(matchItem)
                                const updatedRunners = getMatchOdds(matchItem)?.runners;

                                if (updatedRunners) {
                                    if (matchItem.matchodd[0].runners.length === 1) {
                                        // Check if updatedExchangeItem.matchodd.runners[0] is defined
                                        if (updatedRunners[0]?.layPrices && updatedRunners[0]?.backPrices) {
                                            matchItem.matchodd[0].runners[0].layPrices = updatedRunners[0].layPrices;
                                            matchItem.matchodd[0].runners[0].backPrices = updatedRunners[0].backPrices;
                                        }
                                    } else if (matchItem.matchodd[0].runners.length === 2) {
                                        // Check if updatedExchangeItem.matchodd.runners[0] and [1] are defined
                                        if (updatedRunners[0]?.layPrices && updatedRunners[0]?.backPrices) {
                                            matchItem.matchodd[0].runners[0].layPrices = updatedRunners[0].layPrices;
                                            matchItem.matchodd[0].runners[0].backPrices = updatedRunners[0].backPrices;
                                        }
                                        if (updatedRunners[1]?.layPrices && updatedRunners[1]?.backPrices) {
                                            matchItem.matchodd[0].runners[1].layPrices = updatedRunners[1].layPrices;
                                            matchItem.matchodd[0].runners[1].backPrices = updatedRunners[1].backPrices;
                                        }
                                    } else if (matchItem.matchodd[0].runners.length === 3) {
                                        // Check if updatedExchangeItem.matchodd.runners[0], [1], and [2] are defined
                                        if (updatedRunners[0]?.layPrices && updatedRunners[0]?.backPrices) {
                                            matchItem.matchodd[0].runners[0].layPrices = updatedRunners[0].layPrices;
                                            matchItem.matchodd[0].runners[0].backPrices = updatedRunners[0].backPrices;
                                        }
                                        if (updatedRunners[1]?.layPrices && updatedRunners[1]?.backPrices) {
                                            matchItem.matchodd[0].runners[1].layPrices = updatedRunners[1].layPrices;
                                            matchItem.matchodd[0].runners[1].backPrices = updatedRunners[1].backPrices;
                                        }
                                        if (updatedRunners[2]?.layPrices && updatedRunners[2]?.backPrices) {
                                            matchItem.matchodd[0].runners[2].layPrices = updatedRunners[2].layPrices;
                                            matchItem.matchodd[0].runners[2].backPrices = updatedRunners[2].backPrices;
                                        }
                                    }
                                } else {
                                    console.error('updatedExchangeItem.matchodd.runners is undefined or empty');
                                }
                            } else {
                                console.error('matchItem.matchodd[0].runners is not an array');
                            }
                        }
                    }
                }

            return (
                <>
                {((shouldShow && types === 'competitions') || (shouldShow && ["7","4339"].includes(matchItem.match.sportId))) ? <div className='series-title'>{currentCompetitionName}</div>:''}
                    {matchItem.casinoStatus ? 
                        <Link to={`/live_casinoInPlay/${matchItem.id}`} className='match-info-row' key={matchindex}>
                            <div className='match-update'>
                            <div className="short-score">
                                <div className='animBorder'>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                                <div className="block left">
                                    <span>In Play</span>
                                </div>
                            </div>
                            <div className='match-live-status'>Live</div>
                        </div>
                        <div className='match-name'>
                            <strong>{matchItem.name}</strong>
                            <div className='match-live-status'>Live</div> 

                            <div className='match-stream'>
                                <div className='box'> <span><i className="fa-solid fa-tv"></i></span> </div>
                                <div className='box'> <span><img style={{width:"17px"}} src={icVir} alt="icVir" decoding="async" loading="lazy"/></span> </div>
                            </div>
                        </div>
                        <div className='match-odds'>
                            <div className='box'>
                                <span className='blue'><i className='fa fa-lock'></i></span>
                                <span className='pink'><i className='fa fa-lock'></i></span>
                            </div>
                            <div className='box'>
                                <span className='blue'><i className='fa fa-lock'></i></span>
                                <span className='pink'><i className='fa fa-lock'></i></span>
                            </div>
                            <div className='box'>
                                <span className='blue'><i className='fa fa-lock'></i></span>
                                <span className='pink'><i className='fa fa-lock'></i></span>
                            </div>
                        </div>
                        </Link> :
                        <Link to={`/exchange_inPlay/${matchItem.match.eventId}`} className='match-info-row' key={matchindex}>
                        <div className='match-update'>
                            {matchItem.match.status === 'IN_PLAY' ? <div className="short-score">
                                    <div className='animBorder'>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                <div className="block left">
                                    <span>In Play</span>
                                </div>

                            </div> : ''}
                            {matchItem.match.status === 'IN_PLAY' ? <div className='match-live-status'>Live</div> : ''}
                            <div className='match-date'>
                            {dateFormet(matchItem?.match?.openDate)}
                            </div>

                        </div>
                        <div className='match-name'>
                            <strong>{matchItem.match.eventName}</strong>
                            {matchItem.match.status === 'IN_PLAY' ? <div className='match-live-status'>Live</div> : ''}

                            <div className='match-stream'>
                                {matchItem.match.status === 'IN_PLAY' ? <div className='box'> <span><i className="fa-solid fa-tv"></i></span> </div> : ''}
                                {matchItem?.match?.isvirtual ? <div className='box'> <span><svg xmlns="http://www.w3.org/2000/svg" height={'20px'} width={'20px'} fill={'var(--primary-color)'} viewBox="0 0 640 512"><path d="M638.59 368.22l-33.37-211.59c-8.86-50.26-48.4-90.77-100.66-103.13h-.07a803.19 803.19 0 0 0-369 0C83.17 65.86 43.64 106.36 34.78 156.63L1.41 368.22C-8.9 426.73 38.8 480 101.51 480c49.67 0 93.77-30.07 109.48-74.64l7.52-21.36h203l7.49 21.36C444.72 449.93 488.82 480 538.49 480c62.71 0 110.41-53.27 100.1-111.78zM280 236a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52h-52a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm152 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"/></svg></span></div> :'' }
                                {matchItem?.MatchOddCount > 0 ? <div className='box'> <span className='blue-bg'>MO</span> </div> : ''}
                                {matchItem?.BMcount > 0 ? <div className='box'> <span className='blue-bg'>BM</span> </div> : ''}
                                {matchItem?.FANCYcount > 0 ? <div className='box'> <span className='blue-bg'>F</span> </div> : ''}
                                {matchItem?.TossCount > 0 ? <div className='box'> <span className='blue-bg'>T</span> </div> : ''}
                            </div>
                        </div>
                        <div className='match-odds uniqmarketId' data-id={matchItem?.MatchOddCount > 0 ? matchItem.matchodd[0].marketId :'' }>
                            <div className='box'>
                            <BackPricesBoxExch
                                price={matchItem.matchodd[0]?.runners[0]?.backPrices[0]?.price}
                                position={0}
                                validationBM={validationBM}
                                getLock={getLock}
                                getBoxValue={(lay) => (
                                    <>
                                        {lay}
                                    </>
                                )}
                                />

                                <LayPricesBoxExch
                                    price={matchItem.matchodd[0]?.runners[0]?.layPrices[0]?.price}
                                    position={0}
                                    validationBM={validationBM}
                                    getLock={getLock}
                                    getBoxValue={(lay) => (
                                        <>
                                            {lay}
                                        </>
                                    )}
                                    />
                            </div>

                            {matchItem.matchodd[0]?.runners.length === 3 ?
                            <div className='box'>
                            <BackPricesBoxExch
                                price={matchItem.matchodd[0]?.runners[2]?.backPrices[0]?.price}
                                position={2}
                                validationBM={validationBM}
                                getLock={getLock}
                                getBoxValue={(lay) => (
                                    <>
                                        {lay}
                                    </>
                                )}/>

                                <LayPricesBoxExch
                                    price={matchItem.matchodd[0]?.runners[2]?.layPrices[0]?.price}
                                    position={2}
                                    validationBM={validationBM}
                                    getLock={getLock}
                                    getBoxValue={(lay) => (
                                        <>
                                            {lay}
                                        </>
                                    )}
                                    />
                        </div> :
                            <div className='box'>
                                <span className='blue'><i className='fa fa-lock'></i></span>
                                <span className='pink'><i className='fa fa-lock'></i></span>
                            </div>}

                            <div className='box'>
                            <BackPricesBoxExch
                                price={matchItem.matchodd[0]?.runners[1]?.backPrices[0]?.price}
                                position={1}
                                validationBM={validationBM}
                                getLock={getLock}
                                getBoxValue={(lay) => (
                                    <>
                                        {lay}
                                    </>
                                )}/>

                            <LayPricesBoxExch
                                price={matchItem.matchodd[0]?.runners[1]?.layPrices[0]?.price}
                                position={1}
                                validationBM={validationBM}
                                getLock={getLock}
                                getBoxValue={(lay) => (
                                    <>
                                        {lay}
                                    </>
                                )}
                                />
                            </div>
                        </div>
                    </Link>}
                    
            </>
            )
        }) : (
        <p>Match Not Found</p>
      ))
    }
    

    const renderHRGH = (gameItem) => {
        let lastSeries = null;
        return gameItem.matchData.map((matchItem, matchindex) => {
            let currentCompetitionName
            let shouldShow
            currentCompetitionName = matchItem.match.competitionName.split("-")[0];
            shouldShow = lastSeries !== currentCompetitionName;
            lastSeries = currentCompetitionName;
            return (
                <>
                {shouldShow ? <div className='series-title'>{currentCompetitionName}</div>:''}
                <div className='match-info-row'>
                    <div className='match-name'>
                        <strong>{matchItem.match.eventName}</strong>
                    </div>
                    <div className='match-odds time-tag'>
                        {matchItem.HRGHMO.map((market,marketIndex)=>{
                            let date = new Date(market.marketTime);
                            let isShow = false
                            if(date.getTime() - (1000 * 60 * 15) <= Date.now()){
                                isShow = true
                            }
                            date.setHours(date.getHours() + 5);
                            date.setMinutes(date.getMinutes() + 30);
                            let hours = date.getUTCHours();
                            let minutes = date.getUTCMinutes();
                            let formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
                            return (
                                <div className='box'>
                                {isShow
                                ?
                                    <Link to={`/exchange_inPlay/${matchItem.match.eventId}/${market.marketId}`} key={market.marketId}>
                                    <span
                                        key={market.marketId}
                                        className={`odds-tag live`}
                                        id={market.marketId}
                                    >
                                    {formattedTime}
                                    </span>
                                    </Link>
                                :
                                <span
                                    key={market.marketId}
                                    className={`odds-tag`}
                                    id={market.marketId}
                                    >
                                    {formattedTime}
                                </span>
                                }
                            </div>

                            )
                        })
                        }
                    </div>
                </div>
            </>
            );
        })
    }

    return (
        <>
            {updateMatchOdds && updateMatchOdds?.game && updateMatchOdds.game.length > 0 ? 
            (updateMatchOdds?.game?.map((gameItem, index) => {
                return (
                    <>
                    {gameItem.matchData && gameItem.matchData.length > 0 ?
                    <div className='sport-all-data' key={index}>
                        <div className='match-wrapper'>
                            <div className='heading'>
                                <div className='heading-text sport-name'>
                                    {gameItem.game}
                                </div>
                                <div className='odds-heading'>
                                    {!["GreyHound","HorseRacing"].includes(gameItem.game)?
                                    <>
                                    <div className='heading-text box'>1</div>
                                    <div className='heading-text box'>X</div>
                                    <div className='heading-text box'>2</div>
                                    </>:
                                    ""
                                    }
                                </div>
                            </div>
                            
                            {gameItem.matchData && gameItem.matchData.length > 0 ?
                            <div className='match-data'>
                                <div className='match-list'>
                                    {["GreyHound","HorseRacing"].includes(gameItem.game)?renderHRGH(gameItem):renderData(gameItem)}
                                </div>
                            </div>
                             : <p className='no-data'>Not available {gameItem.game} matches</p>}
                        </div>
                    </div> :
                    <div className='sport-all-data' key={index}>
                        <div className='match-wrapper'>
                            <div className='heading'>
                                <div className='heading-text sport-name'>
                                    {gameItem.game}
                                </div>
                                </div>
                                <div className='match-data'>
                                <div className='match-list'><p className='no-data'>No inplay events!</p></div></div>
                                
                                </div>
                                </div>}</>
                )
            })):<p className='no-data'>No data available</p>}

        </>
    )

}

export default AllsportdataTest;



